import { Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface CalendarTimeAndTypeProps {
  time?: string | null
  typeLabel?: string | null
  className?: string
}

// Four surfaces pair a time with a type; the separator and the order live
// here so they cannot drift apart. Either half alone is a valid line.
export function CalendarTimeAndType({
  time,
  typeLabel,
  className
}: CalendarTimeAndTypeProps) {
  if (!time && !typeLabel) return null

  return (
    <Flex align="center" gap={3} className={`min-w-0 ${className || ""}`}>
      {!!time && (
        <Text ellipsis className={"text-inherit shrink-0"}>
          {time}
        </Text>
      )}
      {!!time && !!typeLabel && (
        <span className={"shrink-0 opacity-50"}>·</span>
      )}
      {!!typeLabel && (
        <Text ellipsis className={"text-inherit"}>
          {typeLabel}
        </Text>
      )}
    </Flex>
  )
}
